import { memo } from 'react';
import { Handle } from 'reactflow';
import "./styles.css";

const RedTriangleNode = memo(({ data }) => {
  return (
    <div className="int__red-triangle-node">
      <Handle
        type="target"
        position="top"
        id="input"
        style={{ width: 0, height: 0, top: 10, border: "none", backgroundColor: "transparent" }}
      />
      <div
        style={{
          marginTop: "19px",
          marginLeft: "-90px"
        }}>
        <input className="nodrag" type="text" defaultValue={data.label} disabled style={{ textAlign: "center", width: 170, fontSize: 13 }} />
      </div>
      <Handle
        type="target"
        position="left"
        id="input_left"
        style={{ width: 0, height: 0, top: 26, left: -85, backgroundColor: "transparent" }}
      />
      <Handle
        type="source"
        position="right"
        id="output_right"
        style={{ width: 0, height: 0, top: 26, right: -75, backgroundColor: "transparent" }}
      />
      <Handle
        type="source"
        position="bottom"
        id="output"
        style={{ width: 0, height: 0, bottom: -26, border: "none", backgroundColor: "transparent" }}
      />
    </div>
  );
});

RedTriangleNode.displayName = 'RedTriangleNode';
export default RedTriangleNode;